import { render, staticRenderFns } from "./StatsBar.vue?vue&type=template&id=6fff1c10&scoped=true"
import script from "./StatsBar.vue?vue&type=script&lang=js"
export * from "./StatsBar.vue?vue&type=script&lang=js"
import style0 from "./StatsBar.vue?vue&type=style&index=0&id=6fff1c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fff1c10",
  null
  
)

export default component.exports